var _path, _path2, _g, _path3, _path4, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowsUp(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 24,
    viewBox: "0 0 12 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.35 16.85L6.35 19.85C6.25 19.95 6.15 20 6 20C5.85 20 5.75 19.95 5.65 19.85L2.65 16.85C2.45 16.65 2.45 16.35 2.65 16.15C2.85 15.95 3.15 15.95 3.35 16.15L6 18.8L8.65 16.15C8.85 15.95 9.15 15.95 9.35 16.15C9.55 16.35 9.55 16.65 9.35 16.85Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_33_948",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 16,
    width: 8,
    height: 4
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.35 16.85L6.35 19.85C6.25 19.95 6.15 20 6 20C5.85 20 5.75 19.95 5.65 19.85L2.65 16.85C2.45 16.65 2.45 16.35 2.65 16.15C2.85 15.95 3.15 15.95 3.35 16.15L6 18.8L8.65 16.15C8.85 15.95 9.15 15.95 9.35 16.15C9.55 16.35 9.55 16.65 9.35 16.85Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_33_948)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 12,
    width: 12,
    height: 12,
    fill: "#BABFC7"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.35 7.85C9.25 7.95 9.15 8 9 8C8.85 8 8.75 7.95 8.65 7.85L6 5.2L3.35 7.85C3.15 8.05 2.85 8.05 2.65 7.85C2.45 7.65 2.45 7.35 2.65 7.15L5.65 4.15C5.85 3.95 6.15 3.95 6.35 4.15L9.35 7.15C9.55 7.35 9.55 7.65 9.35 7.85Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_33_948",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 4,
    width: 8,
    height: 4
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.35 7.85C9.25 7.95 9.15 8 9 8C8.85 8 8.75 7.95 8.65 7.85L6 5.2L3.35 7.85C3.15 8.05 2.85 8.05 2.65 7.85C2.45 7.65 2.45 7.35 2.65 7.15L5.65 4.15C5.85 3.95 6.15 3.95 6.35 4.15L9.35 7.15C9.55 7.35 9.55 7.65 9.35 7.85Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_33_948)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "#002D47"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowsUp);
export default __webpack_public_path__ + "static/media/arrows-up.b244a89b.svg";
export { ForwardRef as ReactComponent };